import { defineMessages } from 'react-intl';

export default defineMessages({
    unableToDownload: {
        id: 'twia-tfpa.claim.additionalinformation.documentupload.Unable to Download',
        defaultMessage: 'Unable To Download Documents, Please Try Again Later',
    },
    otherDocument: {
        id: 'twia-tfpa.claim.additionalinformation.documentupload.Other document',
        defaultMessage: 'Other document',
    },
    badFileTypeTitle: {
        id: 'twia-tfpa.claim.additionalinformation.documentupload.Bad File Type Title',
        defaultMessage: 'Bad File Format',
    },
    badFileTypeBody: {
        id: 'twia-tfpa.claim.additionalinformation.documentupload.Bad File Type Body',
        defaultMessage: 'Please upload a supported file format: .3g2, .3gp, .avi, .bmp, .csv, .doc, .docx, .gif, .jpeg, .jpg, .m4a, .mov, .mp3, .mp4, .mpg, .odt, .ogg, .ogv, .pdf, .png, .pps, .ppsx, .ppt, .pptx, .ps, .wav, .wma, .wmv, .xls, .xlsx, .msg, .ods, .txt, .zip.',
    },
    downloadError: {
        id: 'twia-tfpa.claim.common.views.Unable to download file',
        defaultMessage: 'Unable to download file, please check back later',
    },
});
